
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/debtreliefgate/privacy-policy",
      function () {
        return require("private-next-pages/debtreliefgate/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/debtreliefgate/privacy-policy"])
      });
    }
  